var map = {
	"./account_open.svg": "54ce",
	"./address_list.svg": "427e",
	"./app_center.svg": "cb1c",
	"./cooperate_ability.svg": "ce99",
	"./data_secure.svg": "b9af",
	"./docs_admin.svg": "c02b",
	"./file_on_cloud.svg": "5dda",
	"./flexible_store.svg": "ec5e",
	"./format_comp.svg": "b9f1",
	"./massive_user.svg": "b5e3",
	"./msg_notice.svg": "7b48",
	"./office_online_edit.svg": "4b6f",
	"./quick_access.svg": "ad87",
	"./team.svg": "6974",
	"./transform_compatible.svg": "39d4",
	"./transform_img.svg": "bccc",
	"./transform_pdf.svg": "5f71",
	"./transform_txt.svg": "d448"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad07";